import api from "../store/services/api";

export const getCashierHistory = (params) => api.get(`/cashier/`, { params });

export const getOperatorCashier = (params) =>
  api.get(`/cashier/operator/`, { params });

export const getCashierReport = (params) =>
  api.get(`/cashier/${params.cashier_id || params.id}/report/`, { params });

export const getCashierStoredReport = (params) =>
  api.get(`/cashier/${params.cashier_id || params.id}/stored-report/`, {
    params,
  });

export const getCashierReportOrders = (params) =>
  api.get(`/cashier/operator/report/orders/history/`, { params });

export const getCashierReportUnfinishedOrders = (params) =>
  api.get(`/cashier/${params.id}/pending-orders/`, { params });

export const getCashierReportOrdersPaymentMethods = (params) =>
  api.get(`/cashier/${params.id}/payment-methods/`, { params });

export const getLastCashier = (params) =>
  api.get(`/cashier/operator/last/`, { params });

export const getLastCashierAnyOperator = (params) =>
  api.get(`/cashier/last/`, { params });

export const openCashier = (cashier) =>
  api.post(`/cashier/operator/`, cashier, {
    headers: { "Content-Type": "application/json" },
  });

export const endCashier = (params) =>
  api.post(`/cashier/${params.id}/close/`, params);

export const getCashierTransactions = (cashierId, params) =>
  api.get(`/cashier/${cashierId}/transaction/`, { params });

export const createCashierTransaction = (cashierId, cashier) =>
  api.post(`/cashier/${cashierId}/transaction/`, cashier, {
    headers: { "Content-Type": "application/json" },
  });

export const setCashierTransactionAsResolved = async (
  cashierId,
  transactionId
) =>
  await api.put(
    `/cashier/${cashierId}/${transactionId}/resolved/`,
    {},
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const deleteCashierTransaction = (cashierId, params) =>
  api.delete(`/cashier/${cashierId}/transaction/`, {
    data: params,
  });

export const getCashierPaymentMethodTransfer = (params) =>
  api.get(`/cashier/transfers/`, { params });

export const createCashierPaymentMethodTransfer = (body) =>
  api.post(`/cashier/transfers/`, body, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteCashierPaymentMethodTransfer = (
  cashierPaymentMethodTransferId
) => api.delete(`/cashier/transfers/${cashierPaymentMethodTransferId}/`, {});

export const startClosingCashier = async (cashierId) =>
  await api.put(
    `/cashier/${cashierId}/closing/start/`,
    {},
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const cancelClosingCashier = async (cashierId) =>
  await api.put(
    `/cashier/${cashierId}/closing/cancel/`,
    {},
    {
      headers: { "Content-Type": "application/json" },
    }
  );

const CashierService = {
  getCashierHistory,
  getOpenCashier: getOperatorCashier,
  getCashierReport,
  getCashierStoredReport,
  getCashierReportOrders,
  getLastCashier,
  getLastCashierAnyOperator,
  openCashier,
  endCashier,
  getCashierReportOrdersPaymentMethods,
  createCashierTransaction,
};

export default CashierService;
